import React, { useState } from 'react';
import {Grid} from 'semantic-ui-react';
import InputField from '../formComponents/inputField';
import { AddDropdown } from '../dropdown/AddDropdown';
import DeleteIcon from '../deleteIcon';
import { useDispatch, useSelector } from 'react-redux'
import { validation } from '../../GB_App/util/cdsFieldPatterns';
import {addContainerTabWarnings,deleteContainerTabWarnings } from "../../GB_App/actions/errorValidationActions";
import { useCurrentShipmentType } from '../../hooks/useCurrentShipmentType';
 

function ContainerList(props) {
  const {serviceType} = useCurrentShipmentType()
  const { idx, errorInfo, fieldPattern, validateError, resetContainerErrors, isImportShipment, item, deleteData, updateData, saveData } = props
  const dispatch = useDispatch()
  const {id,containerNumber,sealNumber,sizeType,totalPackages,holdStatus,grossMass,landedStatus} = item
  const isFormDisabled = false;
  const {declarationCat = ''} = useSelector((state) => state.Shipment)
  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'containersTab'),
    [declarationCat]
  )
  const addErrors = (level, value, fieldName) => {
    dispatch(addContainerTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteContainerTabWarnings(level, value, fieldName))
  }

  return (

    <Grid.Row>
      <Grid.Column
        width="2"
        className="divFormFeild border-bottom b-rw-0"
      >
        <InputField
          isLabel={false}
          id={`containerNumber-${id}`}
          type="text"
          boxNumber={serviceType ==='EX' ? "7/10" :''}
          label="Number"
          value={containerNumber}
          errors={
            isImportShipment ? 
            getValidationError("containerNumber",containerNumber) : 
            errorInfo[`container${idx+1}_containerNumber`]?.msg
          }
          className={"field-bg"}
          clearInput={false}
          maxlength={11}
          clearable
          onChange={(value) => updateData(id, {"containerNumber":value })}
          onBlur={(value) =>{(saveData({id,containerNumber:containerNumber||" "}))
          const key = `container${idx+1}_containerNumber`
          validateError({[`${key}`]:''},{[`${key}`]:value},{[`${key}`]:fieldPattern({conIdx:idx})?.containers['containerNumber']}) // M

          let err = getValidationError('containerNumber', containerNumber, 'containersTab')
                err.length
                  ? addErrors('containersTab', err[0], `containerNumber${id}`)
                  : deleteErrors('containersTab', '', `containerNumber${id}`)
        }}
          disabled={isFormDisabled}
        />
      </Grid.Column>
      <Grid.Column
        width="2"
        className="divFormFeild border-bottom b-rw-0 "
      >
        <InputField
          isLabel={false}
          id= {`sealNumber-${id}`}
          type="text"
          boxNumber={serviceType ==='EX' ? "7/18" :''}
          label="Seal No."
          value={sealNumber}
          errors={getValidationError("sealNumber",sealNumber)}
          className={"field-bg"}
          clearable
          onChange={(value) => updateData(id, {"sealNumber":value })}
          onBlur={(value) =>{(saveData({id,sealNumber:sealNumber||" "}))
          let err = getValidationError('sealNumber', sealNumber, 'containersTab')
                err.length
                  ? addErrors('containersTab', err[0], `sealNumber${id}`)
                  : deleteErrors('containersTab', '', `sealNumber${id}`)
        }}
          disabled={isFormDisabled}
        />
      </Grid.Column>

      <Grid.Column
        width="2"
        className="divFormFeild border-bottom b-rw-0"
      >
        <AddDropdown
          id={`sizeType-${id}`}
          disabled={isFormDisabled}
          label="Size Type"
          type="containersSizeType"
          country="UK-CDS"
          clearable
          onSelect={(value) => {
            updateData(id, {"sizeType":value.value})
            saveData({id,sizeType:value.value||" "})   
          }}
          onBlur={({ value }) => {
            if(!value.value?.trim()){
              updateData(id,{sizeType:" "})
              saveData({id,sizeType:" "})
            }
          }}

          selectedValue={sizeType}
         
        />
      </Grid.Column>

      <Grid.Column
        width="2"
        className="divFormFeild border-bottom b-rw-0"
      >
        <InputField
          isLabel={false}
          id= {`totalPackages-${id}`}
          type="text"
          label="Total Pkgs."
          value={totalPackages}
          className={"field-bg"}
          clearInput={false}
          clearable
          onChange={(value) => updateData(id, {"totalPackages":value })}
          onBlur={(value) =>(saveData({id,totalPackages:totalPackages||" "}))}
          disabled={isFormDisabled}
        />
      </Grid.Column>

      <Grid.Column
        width="2"
        className="divFormFeild border-bottom b-rw-0 "
      >
        <InputField
          isLabel={false}
          id={`grossMass-${id}`}
          type="text"
          label="Gross Mass(kg)"
          value={grossMass}
          className={"field-bg"}
          clearInput={false}
          clearable
          onChange={(value) => updateData(id, {"grossMass":value })}
          onBlur={(value) =>(saveData({id,grossMass:grossMass||" "}))}          
          disabled={isFormDisabled}
        />
      </Grid.Column>

      <Grid.Column
        width="3"
        className="divFormFeild border-bottom b-rw-0"
      >
        <InputField
          isLabel={false}
          id= {`landedStatus-${id}`}
          type="text"
          label="Landed Status"
          value={landedStatus}
          className={"field-bg"}
          clearInput={false}
          clearable
          onChange={(value) => updateData(id, {"landedStatus":value })}
          onBlur={(value) =>(saveData({id,landedStatus:landedStatus||" "}))}
          disabled={isFormDisabled}
        />
      </Grid.Column>

      <Grid.Column
        width="2"
        className="divFormFeild border-bottom "
      >
        <InputField
          isLabel={false}
          id= {`holdStatus-${id}`}
          type="text"
          label="Hold Status"
          value={holdStatus}
          className={"field-bg"}
          clearInput={false}
          clearable
          onChange={(value) => updateData(id, {"holdStatus":value })}
          onBlur={(value) =>(saveData({id,holdStatus:holdStatus||" "}))}
          disabled={isFormDisabled}
        />
      </Grid.Column>

      <Grid.Column width="1" className="icon-delete-add-info">
        <DeleteIcon id={`deleteConatiner-${id}`} onClick={() => deleteData(id, false, resetContainerErrors)} />
      </Grid.Column>
    </Grid.Row>
  );
}

export default ContainerList;